<template lang="pug">
  v-dialog(
    :value="value"
    @input="close"
    max-width="600px"
  )
    v-card
      v-card-title.headline
        slot(name="header") Удаление
          v-spacer
          v-btn(@click="close" icon)
            v-icon mdi-close
      v-card-text(class="delete-dialog-text")
        slot(name="body") Вы действительно хотите удалить данный объект?
      v-divider
      v-card-actions
        slot(name="actions")
          v-spacer
          v-btn(color="error" @click="onDelete" :loading="loading" text rounded) Удалить
          v-btn(color="warning" @click="close" text rounded) Отмена

</template>

<script>
export default {
  name: 'DeleteDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    request: {
      type: Function,
      default: null,
    },
    requestId: {
      type: Number,
      default: null,
    },
    successMessage: {
      type: String,
      default: 'Объект успешно удален',
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    onDelete() {
      if (!this.request) this.emitDelete();
      if (this.request && this.requestId) {
        this.loading = true;
        this.$rHandler(
          this.request(this.requestId),
          () => {
            this.loading = false;
            this.$toasted.success(this.successMessage, { duration: 3000 });
            this.emitDelete(this.requestId);
            this.close();
          },
          () => {
            this.loading = false;
          },
        );
      }
    },
    emitDelete(emittedData = null) {
      this.$emit('delete', emittedData);
    },
    close() {
      this.$emit('input', false);
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .delete-dialog-text {
    font-size: 1rem;
  }

</style>
